import { defineAgenda, param } from '@/shared/navigation/core';

/** Rides a Walk-around log jsou zatím jen připravené vstupy pro budoucí agendy. */
export const VEHICLE_TAB_KEYS = [
  'general',
  'rides',
  'documents',
  'maintenance',
  'walkAroundLog',
] as const;

export type VehicleTabKey = (typeof VEHICLE_TAB_KEYS)[number];

/**
 * Agenda detailu vozu — jeden formulář pro založení i editaci. Bez `vehicleId` = založení,
 * s `vehicleId` = editace. Otevírá se výběrem v seznamu (`openDetail`), geometrii řídí
 * `layoutMode: 'overlay'`.
 */
export const vehicleDetailAgenda = defineAgenda({
  id: 'app.inventory.vehicle-detail',
  path: 'app/inventory/vehicle',
  open: {
    vehicleId: param.number().optional(),
  },
  state: {
    // Zvolená záložka žije v URL, aby ji obnovil reload i deep-link (ne lokální useState).
    tab: param.enum(VEHICLE_TAB_KEYS).optional(),
  },
  title: 'Vůz',
  icon: 'bus',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
